import { render, staticRenderFns } from "./DescriptionDialog.vue?vue&type=template&id=56e684b4"
import script from "./DescriptionDialog.vue?vue&type=script&lang=js"
export * from "./DescriptionDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports